import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'cards.transactions.empty.title',
        defaultMessage: 'No transaction history yet',
    },
    text: {
        id: 'cards.transactions.empty.text',
        defaultMessage: 'Make your first transactions and we will show them here',
    },
    blockedText: {
        id: 'cards.transactions.empty.blocked_text',
        defaultMessage:
            'To make transactions <a href={supportLink} rel="noopener noreferrer" data-pointer="history_support" target="_blank">contact support</a>',
    },
})
